import { MediaState } from '../domain/media-file.types';
import { MediaEvent } from '../media.events';

export const videoFilesReducer = (
  state: MediaState,
  event: MediaEvent
): MediaState => {
  return state.map((file) => {
    if (file.type !== 'video') {
      return file;
    }

    switch (event.type) {
      case 'MEDIA/VIDEO_METADATA_LOADED':
        return file.id === event.id
          ? {
              ...file,
              duration: event.duration,
              poster: event.poster,
            }
          : file;
      case 'MEDIA/VIDEO_METADATA_ERROR':
        return file.id === event.id
          ? {
              ...file,
              status: 'error',
              error: 'Не удалось загрузить видео',
            }
          : file;

      default:
        return file;
    }
  });
};
